import React, { FC } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  AnalyzeResourceResponseBodyType,
  ExperienceDto,
} from "@intelligems/ig-types";
import { CircularProgress, Grid } from "@mui/material";
import { UseQueryResult } from "@tanstack/react-query";

import { useSingleExperienceData } from "../../../../api/analysis/analysis";
import { useConfiguration } from "../../../../api/configurations/use-configuration";
import {
  noDecimalCurrencyFormatter,
  selectData,
} from "../../../../api/formatters/dashboard";
import { getExperienceFeFromDto } from "../../../../api/formatters/from-dto/experiences/experiences";
import { BarMetricData } from "../../../../types/analytics";
import { BarGraph } from "../../../Dashboard/Graphs/BarGraph";
import {
  GraphConfig,
  impactGraphConfig,
} from "../../../Dashboard/Graphs/Utils/graphConfigs";
import { IncreaseArrow } from "../../../Dashboard/Graphs/Utils/ImpactArrows";

interface CopiedImpactBarGraphProps {
  experience: ExperienceDto;
  impactMetric: string;
}
export const CopiedImpactBarGraph: FC<CopiedImpactBarGraphProps> = ({
  experience,
  impactMetric,
}) => {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");

  const dashboardData: UseQueryResult<AnalyzeResourceResponseBodyType> =
    useSingleExperienceData(getExperienceFeFromDto(experience), impactMetric);

  const groupWinner = experience.variations.find(
    (group) =>
      group.id === experience.experienceAnalysis.impactWinnerVariationId
  );

  if (dashboardData.isSuccess && groupWinner) {
    return (
      <Grid container direction={"column"}>
        <Grid
          sx={{ marginLeft: "10px" }}
          container
          direction={"row"}
          columnSpacing={1}
          alignItems={"center"}
          textAlign={"center"}
        >
          <Grid item>{!groupWinner.isControl && <IncreaseArrow />}</Grid>
          <Grid item>
            <IgTypography sx={{ fontSize: "16px", fontWeight: 600 }}>
              EST. {groupWinner.isControl ? "-" : "+"}{" "}
              {noDecimalCurrencyFormatter(
                experience.experienceAnalysis.impact!,
                false,
                storeCurrencyConfig!.value!
              )}{" "}
              MONTHLY {groupWinner.isControl && "LOSS AVOIDANCE"}
            </IgTypography>
          </Grid>
        </Grid>
        <Grid item sx={{ marginLeft: "18px", marginBottom: "10px" }}>
          <IgTypography sx={{ fontSize: "14px" }}>
            {
              (
                impactGraphConfig[
                  impactMetric === "revenue" ? 0 : 1
                ] as GraphConfig
              ).title
            }
          </IgTypography>
        </Grid>

        <BarGraph
          config={
            impactGraphConfig[impactMetric === "revenue" ? 0 : 1] as GraphConfig
          }
          groupMetricData={
            selectData(
              "experiences",
              [dashboardData],
              impactGraphConfig[
                impactMetric === "revenue" ? 0 : 1
              ] as GraphConfig,
              getExperienceFeFromDto(experience),
              undefined,
              undefined,
              experience.variations || []
            ) as BarMetricData[]
          }
          filterMethod={undefined}
          compareGroupA={
            experience.variations.find((group) => group.isControl)!.id
          }
          compareGroupB={groupWinner.id}
          resource={getExperienceFeFromDto(experience)}
          resourceType={"experiences"}
        />
      </Grid>
    );
  }
  return (
    <Grid
      item
      container
      direction={"column"}
      alignItems={"center"}
      sx={{ minHeight: "300px" }}
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};
